import { b as b$2, a } from './chunk-4NAYQGFM.mjs';
import { b as b$1 } from './chunk-26IU2X5T.mjs';
import { forwardRef } from 'react';
import c, { css } from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var w=c.svg`
  animation: spinner 0.6s linear infinite;

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }
`,s=()=>jsxs(w,{width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsx("title",{children:"Loading"}),jsx("circle",{cx:"12",cy:"12",r:"11",stroke:"#99A6BF",strokeWidth:"2",strokeLinecap:"round"}),jsx("path",{d:"M12 1C14.5193 1 16.8573 1.80549 18.7879 3.18182",stroke:"#FFFFFF",strokeWidth:"2",strokeLinecap:"round"})]});var L=c.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`,F=css`
  justify-content: center;
  align-items: center;
  padding: none;
  width: 42px;
  height: 42px;
  > ${b$1} {
    width: 16px;
    height: 16px;
  }
`,S=css`
  --padding-vertical: calc(var(--spacing-small) + 1px);
  --padding-horizontal: calc(var(--spacing-regular) + 1px);
  transition: background 0.3s ease, box-shadow 0.5s ease, box-shadow 0.5s;
  padding: var(--padding-vertical) var(--padding-horizontal);
  border-width: 0;
  background: var(--background-button-primary-default);
  color: var(--foreground-button-primary-default);

  :hover:not(:active):not([disabled]) {
    background: var(--background-button-primary-hover);
    color: var(--foreground-button-primary-hover);
  }

  :active:not([disabled]) {
    border-color: transparent;
  }

  &[disabled] {
    background: var(--background-button-primary-disabled);
    border-color: transparent;
  }
`,C=css`
  background: transparent;
  border-color: var(--border-button-secondary-default);
  color: var(--foreground-button-secondary-default);

  :hover:not(:active):not([disabled]) {
    background: var(--background-button-secondary-hover);
    color: var(--foreground-button-secondary-hover);
  }

  :active:not([disabled]) {
    background: var(--background-button-secondary-active);
    color: var(--foreground-button-secondary-active);
  }

  &[disabled] {
    color: var(--foreground-button-secondary-disabled);
    border-color: var(--border-button-secondary-disabled);
    background: transparent;
    svg {
      color: var(--foreground-button-secondary-disabled);
    }
  }
`,W=css`
  background: transparent;
  border-color: none;
  color: var(--foreground-button-tertiary-default);

  :hover:not(:active):not([disabled]) {
    background: var(--background-button-tertiary-hover);
    color: var(--foreground-button-tertiary-hover);
  }

  :active:not([disabled]) {
    background: var(--background-button-tertiary-active);
    color: var(--foreground-button-tertiary-active);
    border-color: transparent;
  }

  &[disabled] {
    color: var(--foreground-button-tertiary-disabled);
    border-color: none;
    background: transparent;
    svg {
      color: var(--foreground-button-secondary-disabled);
    }
  }
`,E=css`
  background: var(--background-button-destructive-default);
  border-color: none;
  color: var(--foreground-button-destructive-default);

  :hover:not(:active):not([disabled]) {
    background: var(--background-button-destructive-hover);
    color: var(--foreground-button-destructive-hover);
  }

  :active:not([disabled]) {
    border-color: transparent;
  }

  &[disabled] {
    background: var(--background-button-destructive-disabled);
    border-color: none;
  }
`,T=css`
  width: 100%;
  text-align: center;
`,l=css`
  pointer-events: none;
  color: transparent;
`,M=c.button`
  min-width: 40px;
  border-width: var(--border-width-x-small);
  border-color: transparent;
  border-style: solid;
  padding: var(--spacing-small) var(--spacing-regular);
  position: relative;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-regular);
  border-radius: var(--border-radius-small);
  letter-spacing: var(--letter-spacing-regular);
  line-height: var(--line-height-regular);
  cursor: pointer;
  display: inline-flex;
  gap: var(--spacing-small);
  justify-content: center;
  align-items: center;
  transition: background 0.3s ease, box-shadow 0.5s ease;
  outline-offset: 4px;
  outline-color: var(--border-button-focus);

  &[disabled] {
    cursor: not-allowed;
  }

  :active:not([disabled]) {
    box-shadow: rgb(189 199 219) 0px 1px 4px, rgb(189 199 219) 0px 0px 0px 3px;
  }

  ${r=>r.$variant==="primary"&&S}
  ${r=>r.$variant==="secondary"&&C}
  ${r=>r.$variant==="tertiary"&&W}
  ${r=>r.$variant==="destructive"&&E}  
  ${r=>r.$loading&&l}  
  &[disabled] {
    ${r=>r.$loading&&l}
  }

  ${r=>r.$iconOnly&&F}

  ${r=>r.$fluid&&T}
`,e={Button:M,LoadingWrapper:L};var b=forwardRef(({variant:r="primary",iconOnly:p=!1,fluid:g=!1,loading:n=!1,children:v,...f},y)=>{let m=b$2(),{setStart:h,setEnd:x}=a("Button",m);h();let k=jsxs(e.Button,{ref:y,$variant:r,$iconOnly:p,$fluid:g,$loading:n,...f,children:[n&&jsx(e.LoadingWrapper,{children:jsx(s,{})}),v]});return x(),k});b.displayName="Button";var z=c(b)``;

export { z as a };
